module.exports = __webpack_public_path__ + "img/7.30fb7b8c.png";